import { PlusCircle } from "@hl/base-components/lib/assets/icons.generated";
import { useModalStack } from "@hl/shared-features/lib/features/modal";
import { Button, ButtonProps, Text } from "@mantine/core";

import {
  _CollectionType,
  TokenDistributionType,
} from "apollo/graphql.generated";
import { ManageSale } from "~/features/manage-collection/mint-vector/ManageSale";
import { GetManageCollectionQuery } from "~/features/manage-collection/v2.queries.graphql.generated";

const CreateDistributionButton = ({
  collection,
  ...rest
}: {
  collection: GetManageCollectionQuery["getManageCollection"];
} & ButtonProps) => {
  const { pushModal, popModal } = useModalStack();

  return (
    <Button
      leftIcon={<PlusCircle />}
      onClick={() =>
        pushModal(
          <CreateDistributionModal
            collection={collection}
            onClose={popModal}
          />,
          {
            size: "lg",
            title: (
              <Text fw={500} size="lg">
                Create a sale
              </Text>
            ),
          }
        )
      }
      {...rest}
    >
      Create a sale
    </Button>
  );
};

const CreateDistributionModal = ({
  collection,
  onClose,
}: {
  collection: GetManageCollectionQuery["getManageCollection"];
  onClose: () => void;
}) => {
  const isCollectorsChoiceCollection =
    collection.collectionType === _CollectionType.Series && !collection.reveal;
  return (
    <ManageSale
      distributionType={TokenDistributionType.Mint}
      firstSale
      collection={collection}
      onClose={onClose}
      isFixedPriceCollection
      enableGatelessPrivateSales={isCollectorsChoiceCollection}
    />
  );
};

export default CreateDistributionButton;
